<template>
    <div id="vehicle_information">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vinInformationHeader">Vehicle Information</span>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vehicle-information">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select"
                                id="VehicleInformationForm">
                                <div class="form-row">
                                    <div class="form-group col-5">
                                        <label class="control-label require" for="vehicle_id">Vin:</label>
                                        <v-select v-model="vehicle_id" id="vehicle_id" name="vehicle_id" label="text"
                                            :filterable="false" :options="vehicleArr" @search="onSearchAsset"
                                            @change="onVinChange" placeholder="Search VIN"
                                            class='custom-ci-auto-search close-remove'>
                                            <template slot="no-options">
                                                Search VIN...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ vehicle_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="from-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups" style="text-align: left;">
                                    <button type="submit" id="searchVinBtn" class="btn btn-primary"
                                        v-on:click.prevent="loadVehicleDetails">
                                        <i class="fp-reload"> </i> Get Details
                                    </button>
                                    <button type="button" id="printBtn" class="btn btn-tertiary"
                                        v-on:click.prevent="printDetails" v-show="showDetails">
                                        <i class="fp-print"> </i> Print Details
                                    </button>
                                    <button type="submit" id="searchVinBtn" class="btn btn-primary" v-show="showDetails"
                                        v-on:click.prevent="loadWorkHistory">
                                        Work History
                                    </button>
                                </div>
                            </form>
                        </section>
                        <work-history ref="workHistory" :claims="workHistoryArr"></work-history>
                    </div>
                    <div id="VehicleData" v-show="showDetails">
                        <vehicle-details ref="vehicleDetail"
                            @vehicle-details-data="handleVehicleData"></vehicle-details>
                        <app-asset-tab-dealer-view @vehicle-customer-data="handleVehicleCustomerData"
                            ref="vehicleDealer"></app-asset-tab-dealer-view>
                        <app-asset-tab-consumer-view @vehicle-consumer-data="handleVehicleConsumerData"
                            ref="vehicleConsumer"></app-asset-tab-consumer-view>
                        <vehicle-dealer-installed-option-details
                            @vehicle-dealer-installed-options-data="handleVehicleDealerInstalledOptionData"
                            ref="vehicleDealerInstalledOptionDetails"></vehicle-dealer-installed-option-details>
                        <vehicle-warranty-details @vehicle-warranty-data="handleVehicleWarrantyData"
                            ref="vehicleWarrantyDetails"></vehicle-warranty-details>
                        <vehicle-campaign-recall-details @vehicle-recall-campaign-data="handleVehicleCampaignRecallData"
                            ref="vehicleCampaignRecallDetails"></vehicle-campaign-recall-details>

                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { commonMixins } from '../mixins/commonMixins';
import { dataTableMixins } from '../mixins/dataTableMixins';
import VehicleWarrantyDetails from "./VehicleWarrantyDetails.vue";
import VehicleCampaignRecallDetails from "./VehicleCampaignRecallDetails.vue";
// import VehicleDetails from "./VehicleDetails.vue";
// Vue.component('vehicle-details', VehicleDetails);
export default {
    name: "VehicleInformation",
    components: {
        appAssetTabDealerView: () => import('@/components/AssetTabDealerView'),
        vehicleDetails: () => import('@/components/VehicleDetails'),
        appAssetTabConsumerView: () => import('@/components/AssetTabConsumerView'),
        VehicleWarrantyDetails: () => import('@/components/VehicleWarrantyDetails'),
        VehicleCampaignRecallDetails: () => import('@/components/VehicleCampaignRecallDetails'),
        VehicleDealerInstalledOptionDetails: () => import('@/components/VehicleDealerInstalledOptionDetails'),
        workHistory: () => import('@/components/workHistory'),
    },
    metaInfo() {
        return { title: "Vehicle Information | " + process.env.COPYRIGHT_NAME }
    },
    mixins: [commonMixins, dataTableMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        velocity_env: process.env.NODE_ENV,
        rows: [],
        loading: false,
        vehicle_id: "",
        vehicle_error_msg: "",
        vehicleArr: [],
        selectedVehicleId: "",
        showDetails: false,
        vehicleData: '',
        customerData: '',
        consumerData: '',
        warrantyData: '',
        campaignRecallData: '',
        dealerInstalledOptionData: '',
        workHistoryArr: [],
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ev_view_vehicle') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function () {

    },
    mounted: function () {
        var self = this;
        //self.loadList();
        self.getPermissions();
    },
    methods: {
        onSearchAsset(search, loading) {
            loading(true);
            this.searchField(loading, search, 'vehicle');
        },
        loadVehicleDetails() {
            var self = this;
            self.vehicle_error_msg = "";
            if (self.vehicle_id != '') {
                self.showDetails = true;
                self.selectedVehicleId = self.vehicle_id.value;
                this.$refs.vehicleDetail.loadVehicleDetails(self.selectedVehicleId);
                this.$refs.vehicleDealer.assetOwnershipTabViewData(self.selectedVehicleId);
                this.$refs.vehicleConsumer.assetOwnershipTabViewData(self.selectedVehicleId);
                this.$refs.vehicleWarrantyDetails.getAssetWarranties(self.selectedVehicleId);
                this.$refs.vehicleCampaignRecallDetails.getCampaignRecalls(self.selectedVehicleId);
                this.$refs.vehicleDealerInstalledOptionDetails.getDealerInstalledOptions(self.selectedVehicleId);
            } else {
                self.showDetails = false;
                self.vehicle_error_msg = "Vin number should be selected"
            }
            // self.loading = true;

        },
        onVinChange(newValue) {
            if (newValue == null) {
                this.vehicle_id = '';
                this.vehicleArr = [];
                this.showDetails = false;
            }
        },
        handleVehicleData(vehicleData) {
            this.vehicleData = vehicleData;
        },
        handleVehicleCustomerData(customerData) {
            this.customerData = customerData;
        },
        handleVehicleConsumerData(consumerData) {
            this.consumerData = consumerData;
        },
        handleVehicleWarrantyData(warrantyData) {
            this.warrantyData = warrantyData;
        },
        handleVehicleCampaignRecallData(campaignRecallData) {
            this.campaignRecallData = campaignRecallData;
        },
        handleVehicleDealerInstalledOptionData(dealerInstalledOptionData) {
            this.dealerInstalledOptionData = dealerInstalledOptionData;
        },
        printDetails() {
            var self = this;
            this.$refs.vehicleDetail.emitDataToParent();
            this.$refs.vehicleDealer.emitDataToParent();
            this.$refs.vehicleConsumer.emitDataToParent();
            this.$refs.vehicleWarrantyDetails.emitDataToParent();
            this.$refs.vehicleCampaignRecallDetails.emitDataToParent();
            this.$refs.vehicleDealerInstalledOptionDetails.emitDataToParent();

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + '/generate-vehicle-information-pdf',
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                data: {
                    vehicleData: self.vehicleData,
                    consumerData: self.consumerData,
                    customerData: self.customerData,
                    warrantyData: self.warrantyData,
                    campaignRecallData: self.campaignRecallData,
                    dealerInstalledOptionData: self.dealerInstalledOptionData,
                },
                success: function (data) {
                    self.loading = false;
                    var pdfPath = data.content;
                    var link = document.createElement('a');
                    link.href = pdfPath;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    self.$parent.loading = false;
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'asset-load-view')

                }
            });
        },
        loadWorkHistory() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/get-work-history/" + self.vehicle_id.value,
                type: "GET",
                headers: {
                    'Accept': 'application/json',
                    "Access-Control-Allow-Origin": '*',
                    "Authorization": "Bearer " + localStorage.getItem("tkn"),
                    'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                    "Cache-Control": "no-cache"
                },
                crossDomain: true,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    self.$refs.vehicleDetail.emitDataToParent();
                    self.$refs.vehicleConsumer.emitDataToParent();
                    self.workHistoryArr = data.content;
                    $("#workHistoryModal").modal('show');
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'asset-load-view')
                }
            });
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/VehicleInformation.vue